import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getOnlineRegistration } from "../Service/Api";
import { Link } from "react-router-dom";

const OnlineRegistration = () => {
  // Fetch data using React Query
  const { data = [] } = useQuery({
    queryKey: ["online-registration"],
    queryFn: getOnlineRegistration,
  });

  const emptyArray = [];

  return (
    <>
      {data.length > 0
        ? data.map((item, index) => (
            <div className="OnlineR" key={index}>
              <span className="bounce1">
                <Link to={item.url} target="_blank" className="parantlogo">
                  {item.title}
                </Link>

                {/* Show paperclip icon if there’s an attachment */}
                {item.attachments && item.attachments[0] && (
                  <Link
                    to={`https://webapi.entab.info/api/image/${item.attachments[0]}`}
                    target="_blank">
                    <i className="bi bi-paperclip"></i>
                  </Link>
                )}
              </span>
            </div>
          ))
        : emptyArray.map((item, index) => <div key={index}></div>)}
    </>
  );
};

export default OnlineRegistration;
